import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

import type { TPaddedValue } from './models';

export const paddedTypesCommon: Record<TPaddedValue, IStyler> = {
    standard: {
        paddingTop: 64,
        paddingBottom: 64,
        paddingLeft: 0,
        paddingRight: 0,
    },
    sticky: {
        paddingTop: 24,
        paddingBottom: 24,
        paddingLeft: 0,
        paddingRight: 0,
    },
    normal: {
        paddingTop: 48,
        paddingBottom: 48,
        paddingLeft: 0,
        paddingRight: 0,
    },
    perimeter: {},
    perimeter16: {
        padding: 16,
    },
    perimeter24: {
        padding: 24,
    },
    perimeter32: {
        padding: 32,
    },
    perimeter48: {
        padding: 48,
    },
};

export const paddedTypesDesktop: Record<TPaddedValue, IStyler> = {
    ...paddedTypesCommon,
    perimeter: {
        paddingTop: 32,
        paddingBottom: 32,
        paddingLeft: 32,
        paddingRight: 32,
    },
};

export const paddedTypesMobile: Record<TPaddedValue, IStyler> = {
    ...paddedTypesCommon,
    perimeter: {
        paddingTop: 24,
        paddingBottom: 24,
        paddingLeft: 16,
        paddingRight: 16,
    },
};

export const pads = [
    { value: 'standard', description: 'По вертикали: 64px, по горизонтали: 0px' },
    { value: 'sticky', description: 'По вертикали: 24px, по горизонтали: 0px' },
    { value: 'perimeter', description: 'Отступ сверху-снизу: 24px; отступ слева и справа: 16px' },
    { value: 'perimeter16', description: '16px' },
    { value: 'perimeter24', description: '24px' },
    { value: 'perimeter32', description: '32px' },
    { value: 'perimeter48', description: '48px' },
    { value: 'normal', description: 'Отступ сверху-снизу: 48px; отступ слева и справа: 0px' },
] as const;

export const themes = [
    { value: 'transparent', description: 'Прозрачный' },
    { value: 'white', description: 'Белый' },
    { value: 'grey', description: 'Серый' },
    { value: 'blue', description: 'Синий' },
    { value: 'black', description: 'Черный' },
    { value: 'lightInverted', description: 'Тёмно-синий' },
] as const;

export const BORDER_RADIUS_OPTIONS = [
    { value: 0 },
    { value: 4 },
    { value: 8 },
    { value: 12 },
] as const;
